import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";
import { EntityGroupResponse } from "~types/entityGroup.ts";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectEntityGroup = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: EntityGroupResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameFullLocal, value: x.entityGroupId }));

  return (
    <InfinitySelect<EntityGroupResponse>
      {...props}
      url={`${sport}/o/${organizationId}/entityGroups`}
      searchParameter="nameFullLocalContains"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.ENTITY_GROUP}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
